import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  recordsForm: {
    color: theme.palette.text.primary,
    marginBottom: 16,
    padding: 16,
    borderRadius: 8,
    backgroundColor: `#${theme.app.colors.text.light}`,
    boxShadow: '0 4px 5px #0000001A'
  },

  recordsFormContent: {
    // Espaçamento extra se necessário, mas sem grid, pois usaremos o Grid do Material-UI no JSX
    marginBottom: 16
  },

  reportsDivider: {
    display: 'none',
    [theme.breakpoints.up('sm')]: {
      display: 'unset',
      width: '25%'
    }
  },

  recordsButtonContainer: {
    display: 'flex',
    marginLeft: 'auto',
    alignItems: 'center',
    justifyContent: 'flex-end',
    '& button': {
      width: '100%',
      display: 'flex',
      justifyContent: 'center',
      '& img': {
        width: 22,
        marginRight: 8
      },
      [theme.breakpoints.up('sm')]: {
        width: 148
      }
    }
  },

  disabled: {
    opacity: '1 !important'
  }
}))
